import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var PopupService = /** @class */ (function () {
    function PopupService() {
        this.popupSubject = new Subject();
        this.popupState = this.popupSubject.asObservable();
        this.continueFlow = false;
        this.isRedirecting = false;
        this.continueWithFirmlyApproved = false;
    }
    PopupService.prototype.showPopup = function () {
        this.popupSubject.next({ showPopup: true });
    };
    PopupService.prototype.hidePopup = function (continueFlow, isRedirecting) {
        if (isRedirecting === void 0) { isRedirecting = false; }
        this.popupSubject.next({
            showPopup: false,
            continueFlow: continueFlow,
            isRedirecting: isRedirecting,
        });
    };
    PopupService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PopupService_Factory() { return new PopupService(); }, token: PopupService, providedIn: "root" });
    return PopupService;
}());
export { PopupService };
